// extracted by mini-css-extract-plugin
module.exports = {"heading":"_TzgK4","line-in":"Z2JJvQ"};